import { getApiUrl } from "utils/tcApiUrl";

const trimSlash = (value: string) => value.replace(/\/+$/, "");

export const nexaApiUrl = (path: string): string => {
  const override = process.env.REACT_APP_NEXA_API_URL;
  if (override) return `${trimSlash(override)}/chattrade/${path}`;
  return getApiUrl(`chattrade/${path}`);
};

export const nexaSocketUrl = (threadId: string): string => {
  const override = process.env.REACT_APP_NEXA_WS_URL;
  if (override) return `${trimSlash(override)}/ws/chattrade/${threadId}`;

  const httpBase = trimSlash(getApiUrl(""));
  const scheme = httpBase.startsWith("https://") || window.location.protocol === "https:" ? "wss" : "ws";
  const hostAndPath = httpBase.replace(/^https?:\/\//, "");
  return `${scheme}://${hostAndPath}/ws/chattrade/${threadId}`;
};
